export const TableSectionContent = ({ renderTable }) => renderTable();
